import { useTheme } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import { Line } from 'rc-progress';
import React__default from 'react';
import { getProgressColor } from './Gauge.esm.js';

function LinearGauge(props) {
  const { value, getColor = getProgressColor, width = "thick" } = props;
  const { palette } = useTheme();
  if (isNaN(value)) {
    return null;
  }
  let percent = Math.round(value * 100 * 100) / 100;
  if (percent > 100) {
    percent = 100;
  }
  const lineWidth = width === "thick" ? 4 : 1;
  const strokeColor = getColor({
    palette,
    value: percent,
    inverse: false,
    max: 100
  });
  return /* @__PURE__ */ React__default.createElement(Tooltip, { title: `${percent}%` }, /* @__PURE__ */ React__default.createElement(Typography, { component: "span" }, /* @__PURE__ */ React__default.createElement(
    Line,
    {
      percent,
      strokeWidth: lineWidth,
      trailWidth: lineWidth,
      strokeColor
    }
  )));
}

export { LinearGauge };
//# sourceMappingURL=LinearGauge.esm.js.map
